import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";

import ReusableTissueForm from "./ReusableTissueForm";
import { updateTissue } from "../../actions/tissues";
import ErrorContext from "../../context/ErrorContext";

function EditTissueForm({ selectedTissue, tissueList, id, user }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { setError } = useContext(ErrorContext);

  //update tissue form submission
  async function handleEditTissueFormSubmission(event) {
    event.preventDefault();
    const ext = event.target.MS_Skin_Ext.checked
      ? "MS_Skin_Ext"
      : event.target.MS_Ext.checked
      ? "MS_Ext"
      : event.target.Skin_Ext.checked
      ? "Skin_Ext"
      : event.target.Hv_Ext.checked
      ? "Hv_Ext"
      : event.target.HVN_Ext.checked
      ? "HVN_Ext"
      : "";
    const reg = event.target.MS_Skin_Reg.checked
      ? "MS_Skin_Reg"
      : event.target.MS_Reg.checked
      ? "MS_Reg"
      : event.target.Skin_Reg.checked
      ? "Skin_Reg"
      : event.target.Hv_Reg.checked
      ? "Hv_Reg"
      : event.target.HVN_Reg.checked
      ? "HVN_Reg"
      : "";
    const flight = event.target.MS_Skin_Flight.checked
      ? "MS_Skin_Flight"
      : event.target.MS_Flight.checked
      ? "MS_Flight"
      : event.target.Skin_Flight.checked
      ? "Skin_Flight"
      : event.target.Hv_Flight.checked
      ? "Hv_Flight"
      : event.target.HVN_Flight.checked
      ? "HVN_Flight"
      : "";
    const updatedTissue = {
      tissueName: event.target.tissueName.value,
      ext_score: ext,
      reg_score: reg,
      flight_score: flight,
      id: selectedTissue.id,
      userId: user.userId,
    };

    await dispatch(updateTissue(id, updatedTissue, tissueList))
      .then(() => history.push(`/tissues/${id}`))
      .catch((error) => {
        console.log(error);
        setError(error);
      });
  }
  return (
    <div className="container mt-3">
      <div className="header">
        <Link to="/tissues" className="btn header">
          Return to List
        </Link>
        <hr />
        <h1 className="header_text">Edit Tissue</h1>
        <hr />
      </div>
      <ReusableTissueForm
        selectedTissue={selectedTissue}
        formSubmissionHandler={handleEditTissueFormSubmission}
        buttonText="Update"
      />
    </div>
  );
}

export default EditTissueForm;
